module.exports = __webpack_public_path__ + "img/logo_pec.042db8fb.webp";